// @ts-check
import { action, makeAutoObservable } from 'mobx';
import TracesRequests from "Utils/Requests/TracesRequests";

class TracesStore {
    /** @type {Object.<string, boolean>} */
    tracesKeys;
    dataLoading;
    tracingInProcess;
    tracesEnabled;
    /** @type {FrontTraceRecord[]} */
    traceRecords;

    constructor() {
        makeAutoObservable(this);

        this.tracesKeys = {};
        this.dataLoading = false;
        this.tracingInProcess = false;
        this.tracesEnabled = false;
        this.traceRecords = [];
    }

    /**
     * @param {boolean} tracesEnabled
     */
    SetState(tracesEnabled) {
        this.tracesEnabled = tracesEnabled;
        this.SaveTraces();
    }

    LoadTracesKeys() {
        this.dataLoading = true;

        TracesRequests.GetTracesState()
            .then(action((values) => {
                this.tracesKeys = values.tracesKeys;
                this.tracingInProcess = values.tracingInProcess;
            }))
            .finally(action(() => this.dataLoading = false));
    }

    /**
     * @param {string} key
     * @param {boolean} val
     */
    SetTraceKey(key, val) {
        this.dataLoading = true;

        TracesRequests.SetTraceKey(key, val)
            .finally(action(() => this.dataLoading = false));
    }

    SwitchTracingOn() {
        this.dataLoading = true;

        TracesRequests.SwitchTracingOn()
            .then(action((values) => {
                this.tracingInProcess = values.error == null;
            }))
            .finally(action(() => this.dataLoading = false));
    }

    SwitchTracingOff() {
        this.dataLoading = true;

        TracesRequests.SwitchTracingOff()
            .then(action((values) => {
                if (values.error == null)
                    this.tracingInProcess = false
            }))
            .finally(action(() => this.dataLoading = false));
    }

    PrintTraces() {
        TracesRequests.LoadLogsFile();
    }

    /**
     * @param {string} className
     * @param {string} methodName
     * @param {string} additionalInfo
     * @param {any} variablesValuesObject
     */
    AddTrace(className, methodName, additionalInfo, variablesValuesObject) {
        if (this.tracesEnabled != true)
            return;

        this.traceRecords.push({
            timestamp: new Date(),
            className: className,
            methodName: methodName,
            additionalInfo: additionalInfo,
            variablesValuesJson: JSON.stringify(variablesValuesObject)
        });
    }

    SaveTraces() {
        if (this.traceRecords.length == 0)
            return;

        TracesRequests.SaveTracesFromFront(this.traceRecords);
        this.traceRecords = [];
    }
}

export default new TracesStore();